module.exports = __webpack_public_path__ + "static/img/Group 1346.f2a8f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20240302/Group 1346.png
// module id = 6FfP
// module chunks = 1